import qs from 'query-string';
import { Location } from 'history';

import isRelativeUrl from './isRelativeUrl';

export default function getNextUrl(location: Location | undefined, defaultUrl: string) {
  if (location) {
    const query = qs.parse(location.search);
    if (isRelativeUrl(query.returnURL)) {
      return query.returnURL as string;
    }
    if (query.from === 'summary') {
      return defaultUrl.replace(/[^/]+\/?$/, 'summary/');
    }
  }
  return defaultUrl;
}
